/**
 * Scoring Filters
 *
 * Filters related to investment scores and quality ratings
 * To add a new scoring filter, simply add a new object to this array
 */

import { Filter } from '../../types/filters';

export const scoringFilters: Filter[] = [
  // ===== TOTAL SCORE =====
  {
    id: 'total_score',
    name: 'Total Score',
    description: 'Overall investment score based on all factors (0-100)',
    category: 'scoring',
    type: 'range',
    minTier: 'STARTER',
    premiumFeature: false,
    popularityRank: 13,
    dataPath: 'teaser.totalScore', // Available in teaser
    version: '1.0',
    enabled: true,
    defaultValue: [0, 100],
    config: {
      min: 0,
      max: 100,
      step: 5,
      defaultMin: 0,
      defaultMax: 100,
      unit: '/100',
      format: (value: number) => `${value}/100`,
      presets: [
        { label: 'Good (60+)', value: [60, 100], icon: '' },
        { label: 'Excellent (80+)', value: [80, 100], icon: '' },
        { label: 'Outstanding (90+)', value: [90, 100], icon: '' }
      ]
    }
  },

  // ===== QUALITY RATING =====
  {
    id: 'quality_rating',
    name: 'Quality Rating',
    description: 'Overall quality assessment',
    category: 'scoring',
    type: 'checkbox',
    minTier: 'STARTER',
    premiumFeature: false,
    popularityRank: 14,
    dataPath: 'teaser.qualityRating', // Available in teaser
    version: '1.0',
    enabled: true,
    defaultValue: [],
    config: {
      options: [
        { value: 'EXCELLENT', label: 'Excellent', icon: '' },
        { value: 'GOOD', label: 'Good', icon: '' },
        { value: 'FAIR', label: 'Fair', icon: '' }
      ],
      defaultSelected: [],
      multiSelect: true
    }
  },

  // ===== CRIME SAFETY RATING =====
  {
    id: 'crime_safety',
    name: 'Crime Safety',
    description: 'Police UK safety rating (1=most crime, 7=least crime)',
    category: 'scoring',
    type: 'range',
    minTier: 'STARTER',
    premiumFeature: false,
    popularityRank: 15,
    dataPath: 'teaser.crimeSafetyRating', // Available in teaser
    version: '1.0',
    enabled: true,
    defaultValue: [1, 7],
    config: {
      min: 1,
      max: 10,
      step: 1,
      defaultMin: 1,
      defaultMax: 10,
      unit: '',
      format: (value: number) => `${value}/10`,
      presets: [
        { label: 'Safe (7+)', value: [7, 10], icon: '' },
        { label: 'Very Safe (9+)', value: [9, 10], icon: '' }
      ]
    }
  }
];
